module.exports = "/_next/static/images/de946f90c19d9a736e53f67b62a86267-pj-phone-and-business-card@2x.jpg.webp";